class Tabs {
  constructor(buttons=[]) {
    this.buttons = [...buttons];
    this.init();
  }
  init() {
    this.pages = this.buttons.map(button =>
      document.querySelector(button.dataset.target)
    );
    this.buttons.forEach((button, i) =>
      button.addEventListener("click", () => this.show(i))
    );
    this.show(0);
  }
  show(targetIndex) {
    this.buttons.forEach((button, index) => {
      if (index === targetIndex) {
        button.classList.add("tabs__tab--active");
        this.pages[index].style.display = "";
      } else {
        this.pages[index].style.display = "none";
        button.classList.remove("tabs__tab--active");
      }
    });
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/js/components/tabs.js